import { AxiosInstance } from 'axios';
import {
  GetCompetence,
  GetCompetences,
  parseCompetence,
  parseCompetences,
} from './utils';
import {
  PromiseCompetence,
  PromiseCompetences,
  CompetencesStatusEnum,
} from './types';

export const getCompetencesData = (api: AxiosInstance) => ({
  getCompetences: async (
    params: any,
    dataParser: Function = parseCompetences,
  ): Promise<PromiseCompetences> => {
    const { data } = await api.get<GetCompetences>(
      CompetencesStatusEnum.GET_EVENT_COMPETENCES,
      {
        params,
      },
    );
    return { ...data, data: dataParser(data.data) };
  },
});

export const getCompetenceData = (api: AxiosInstance) => ({
  getCompetence: async (
    id: string,
    dataParser: Function = parseCompetence,
  ): Promise<PromiseCompetence> => {
    const { data } = await api.get<GetCompetence>(
      `${CompetencesStatusEnum.GET_EVENT_COMPETENCE}/${id}`,
    );
    return { ...data, data: dataParser(data.data) };
  },
});

export const competencesService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getCompetencesData(api),
    ...getCompetenceData(api),
  };
};



// WEBPACK FOOTER //
// ./src/services/api/competences/competencesService.ts